import React from 'react';
import { Box } from '@common-fe/common-fe';

import { DelinquentClaimsReportView } from '../DelinquentClaimsReport.types';

import DelinquentClaimsViewPickerItem from './DelinquentClaimsViewPickerItem';

interface Props {
  value: DelinquentClaimsReportView;
  onChangeValue: (value: DelinquentClaimsReportView) => void;
  disabled?: boolean;
}

const DelinquentClaimsViewPicker: React.FC<Props> = ({ value, onChangeValue, disabled }) => {
  return (
    <Box direction="row">
      <Box margin={{ right: 'spacing8' }}>
        <DelinquentClaimsViewPickerItem
          testId="delinquent-claims_by-employee_toggle-button"
          onClick={() => onChangeValue(DelinquentClaimsReportView.ByEmployee)}
          checked={value === DelinquentClaimsReportView.ByEmployee}
          disabled={disabled}
        >
          By Employee
        </DelinquentClaimsViewPickerItem>
      </Box>
      <DelinquentClaimsViewPickerItem
        testId="delinquent-claims_by-claim_toggle-button"
        onClick={() => onChangeValue(DelinquentClaimsReportView.ByClaim)}
        checked={value === DelinquentClaimsReportView.ByClaim}
        disabled={disabled}
      >
        By Claim
      </DelinquentClaimsViewPickerItem>
    </Box>
  );
};

export default DelinquentClaimsViewPicker;
